import classNames from "classnames";
import React from "react";
import styles from "./filterCard.css";

interface Props {
  name: string;
  content?: string;
  onDelete(): void;
}

export const FilterCard = ({ name, content, onDelete }: Props) => {
  const renderText = () => {
    return content ? `${name}: ${content}` : name;
  };

  return (
    <div className={styles.content}>
      <p>{renderText()}</p>
      <i className={classNames("icon-close-cross", styles.icon)} onClick={onDelete} />
    </div>
  );
};
